import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as finalCheckActions from '../../../redux/finalCheckActions';
import * as vanillaDesignActions from '../../../redux/vanillaDesignActions';
import {
  convertImperialToGivenUnitSystem,
  getUniquePremiumContent
} from '../../../utilities/HelperFunctions/HelperFunctions';
import { bindActionCreators } from 'redux';
import Preview from './Preview';
import './VanillaFinalCheck.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import PremiumContentDetails from './PremiumContentDetails';
import { Icons } from '../../../utilities';
import * as pageControllerActions from '../../../redux/pageControllerActions';
import { getPlacings } from '../../../redux/ProjectData/Project';

class VanillaFinalCheck extends Component {
  state = {
    uiProjectName: string.PLACEHOLDER_PROJECT_NAME,
    editProjectName: false
  };

  componentDidMount() {
    // this.renderPreviw();
    const { showFlashMessage, dispatchers } = this.props;
    if (showFlashMessage === null) {
      dispatchers.vanillaDesignActions.HandleFlashMessage(true);

      setTimeout(() => {
        dispatchers.vanillaDesignActions.HandleFlashMessage(false);
      }, 5000);
    }
  }

  componentWillUnmount() {
    const { dispatchers } = this.props;
    dispatchers.pageControllerActions.redirectToCongratulationsPage(true);
  }

  onEditProjectName = e => {
    const { dispatchers } = this.props;
    this.setState({ uiProjectName: e.target.value });
    dispatchers.finalCheckActions.setProjectName(e.target.value);
    dispatchers.fabricCanvasActions.makeProjectDirtyWithNoUndoSupport(true);
  };

  handleEditProjectName = () => {
    const { editProjectName } = this.state;
    this.setState({ editProjectName: !editProjectName });
  };

  renderCongratulationPage = () => {
    const { showFlashMessage } = this.props;

    return (
      <div className='d-flex pt-3'>
        <img
          src={Icons.congratsIcon}
          alt='congrats'
          className='congrats-icon'
        />
        <div>
          <div className='congratulations'>{string.CONGRATULATIONS_KEY}</div>
          <div className='completion-message'>
            {string.FREE_POSTER_COMPLETE_MESSAGE_KEY}
          </div>
        </div>
        {showFlashMessage ? this.notifySave() : null}
      </div>
    );
  };

  notifySave = () => {
    const { dispatchers } = this.props;

    return (
      <div className='toast-container'>
        {string.MY_WORK_SAVE_KEY}
        <div
          role='button'
          aria-label='My work'
          style={{ outline: 0 }}
          tabIndex='0'
          onKeyPress={() => {}}
          onClick={() =>
            dispatchers.vanillaDesignActions.HandleFlashMessage(false)
          }
          className='close-icon'
        />
      </div>
    );
  };

  render() {
    const {
      productSizes,
      selectedDefaultSize,
      orientation,
      unitSystem,
      projectName,
      showCongratulationsPage,
      project
    } = this.props;
    const { uiProjectName, editProjectName } = this.state;

    const placings = getPlacings(project);
    const premiumContent = getUniquePremiumContent(placings);
    const sizeString = ` ${Constants.HYPHEN} ${convertImperialToGivenUnitSystem(
      project.width,
      unitSystem
    )} ${Constants.MULTIPLY} ${convertImperialToGivenUnitSystem(
      project.height,
      unitSystem
    )} ${homeActions.getUnit(unitSystem)}`;

    return (
      <div
        className={`vanilla-final-check d-flex ${
          orientation == 'Landscape' ? 'landscape-style' : 'potrait-style'
        }`}
      >
        <Preview projectName={projectName || uiProjectName} />
        <div className='d-flex flex-column'>
          <div className='design-details'>
            <div>
              <p className='title'>{string.YOUR_PROJECT_KEY}</p>
              <p className='meassage'>{string.VANILLA_PREVIEW_MESSAGE_KEY}</p>
              <span>
                <span className='sub-title'>{string.WALL_POSTER_KEY}</span>
                <span className='poster-name'>
                  {editProjectName ? (
                    <input
                      onBlur={() => this.handleEditProjectName()}
                      className='input-name'
                      type='text'
                      name='project name'
                      value={projectName || uiProjectName}
                      onChange={e => this.onEditProjectName(e)}
                    />
                  ) : (
                    <span>{projectName || uiProjectName}</span>
                  )}
                  <button
                    type='button'
                    style={{
                      border: 'none',
                      background: 'none',
                      outline: 'none'
                    }}
                    onClick={() => this.handleEditProjectName()}
                  >
                    <img
                      src={Icons.editIcon}
                      alt='edit'
                      className='ml-3 mr-3'
                      style={{ cursor: 'pointer' }}
                    />
                  </button>
                </span>
                <span className='vertical-line' />
                <span className='poster-name'>
                  {' '}
                  {selectedDefaultSize === Constants.CUSTOM_SIZE
                    ? selectedDefaultSize.charAt(0).toUpperCase() +
                      selectedDefaultSize.slice(1)
                    : productSizes.default.sizes[selectedDefaultSize].name}{' '}
                  {sizeString}
                </span>
              </span>
              <hr />
            </div>

            {premiumContent.length > 0 && showCongratulationsPage ? (
              <PremiumContentDetails premiumContentList={premiumContent} />
            ) : (
              this.renderCongratulationPage()
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeData: state.modal.storeData,
    unitSystem: state.home.unitSystem,
    orientation: state.home.orientation,
    selectedDefaultSize: state.home.selectedDefaultSize,
    productSizes: state.modal.productSizes,
    showCongratulationsPage: state.pageController.showCongratulationsPage,
    projectName: state.finalCheck.project.name,
    triggerProjectDirty: state.fabricCanvas.triggerProjectDirty,
    showFlashMessage: state.vanilla.showFlashMessage,
    project: state.finalCheck.project
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch),
      vanillaDesignActions: bindActionCreators(vanillaDesignActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VanillaFinalCheck);
